import{VisualizationViewType as t}from"../../visualization.types.js";var i=function(){function i(i){this._config=i,this.type=t.treeChart}return i.prototype.get=function(){return this._config},i}();export{i as TreeChartConfig};
